module.exports = __webpack_public_path__ + "static/media/300_3.c4b8cd72.jpg";